<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="БФП MX532, MX632, XM3350">
     БФП MX532, MX632, XM3350
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_uk" title="Інформація про безпеку">
     Інформація про безпеку
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="Умовні позначення">
      Умовні позначення
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-cable-topic.html#d0e40" title="Заяви щодо виробу">
      Заяви щодо виробу
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter_uk" title="Докладніше про принтер">
     Докладніше про принтер
    </a>
   </p>
   <div id="divd0e175">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_uk" title="Пошук інформації про принтер">
      Пошук інформації про принтер
     </a>
    </p>
    <p class="toc-2-style">
     <a href="finding-printer-serial-number-topic.html#finding-printer-serial-number_uk" title="Пошук серійного номера принтера">
      Пошук серійного номера принтера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations_uk" title="Налаштування принтера">
      Налаштування принтера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_uk" title="Використання панелі керування">
      Використання панелі керування
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light_uk" title="Розуміння статусу світлового індикатора">
      Розуміння статусу світлового індикатора
     </a>
    </p>
    <p class="toc-2-style">
     <a href="selecting-paper-group.html#d0e500" title="Вибір паперу">
      Вибір паперу
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_uk" title="Налаштування, установлення та конфігурування">
     Налаштування, установлення та конфігурування
    </a>
   </p>
   <div id="divd0e1569">
    <p class="toc-2-style">
     <a href="selecting-location-printer-topic.html#selecting-location-printer_uk" title="Вибір місця розташування для принтера">
      Вибір місця розташування для принтера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="attaching-cables-topic.html#attaching-cables_uk" title="Приєднання кабелів">
      Приєднання кабелів
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-home-screen-topic.html#d0e1764" title="Налаштування та використання програм головного екрана">
      Налаштування та використання програм головного екрана
     </a>
    </p>
    <p class="toc-2-style">
     <a href="activating-voice-guidance-topic.html#d0e2411" title="Налаштування та використання спеціальних можливостей">
      Налаштування та використання спеціальних можливостей
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-printer-to-fax-group.html#d0e2717" title="Налаштування передавання факсів на принтері">
      Налаштування передавання факсів на принтері
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-smtp-server-for-e-mail-topic.html#configuring-smtp-server-for-e-mail_uk" title="Налаштування параметрів SMTP електронної пошти">
      Налаштування параметрів SMTP електронної пошти
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-paper-size-and-type-topic.html#d0e4576" title="Завантаження паперу та спеціальних носіїв">
      Завантаження паперу та спеціальних носіїв
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e4742" title="Установлення та оновлення програмного забезпечення, драйверів та мікропрограм">
      Установлення та оновлення програмного забезпечення, драйверів та мікропрограм
     </a>
    </p>
    <p class="toc-2-style">
     <a href="available-internal-options-topic.html#d0e5023" title="Установлення апаратних опцій">
      Установлення апаратних опцій
     </a>
    </p>
    <p class="toc-2-style">
     <a href="wireless-support-topic.html#d0e5332" title="Мережа">
      Мережа
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer_uk" title="Захист принтера">
     Захист принтера
    </a>
   </p>
   <div id="divd0e5757">
    <p class="toc-2-style">
     <a href="locating-security-slot-topic.html#locating-security-slot_uk" title="Розташування гнізда безпеки">
      Розташування гнізда безпеки
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_uk" title="Стирання пам'яті принтера">
      Стирання пам'яті принтера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-storage-drive-topic.html#erasing-printer-storage-drive_uk" title="Стирання накопичувача принтера">
      Стирання накопичувача принтера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_uk" title="Відновлення заводських параметрів за замовчуванням">
      Відновлення заводських параметрів за замовчуванням
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-topic.html#statement-of-volatility_uk" title="Заява про енергозалежність">
      Заява про енергозалежність
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter_uk" title="Друк">
     Друк
    </a>
   </p>
   <div id="divd0e5950">
    <p class="toc-2-style">
     <a href="printing-from-computer-h2-topic.html#printing-from-computer-h2_uk" title="Друк із комп&rsquo;ютера">
      Друк із комп&rsquo;ютера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-topic.html#d0e5976" title="Друк із мобільного пристрою">
      Друк із мобільного пристрою
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-topic.html#printing-from-flash-drive_uk" title="Друк із флешнакопичувача">
      Друк із флешнакопичувача
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-flash-drives-and-file-types-topic.html#supported-flash-drives-and-file-types_uk" title="Підтримувані флешнакопичувачі та типи файлів">
      Підтримувані флешнакопичувачі та типи файлів
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_uk" title="Налаштування конфіденційних завдань">
      Налаштування конфіденційних завдань
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_uk" title="Друк конфіденційних та інших відкладених завдань">
      Друк конфіденційних та інших відкладених завдань
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-h2-topic.html#printing-font-sample-list-h2_uk" title="Друк списку зразків шрифтів">
      Друк списку зразків шрифтів
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-directory-list-h2-topic.html#printing-directory-list-h2_uk" title="Друк списку каталогів">
      Друк списку каталогів
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-topic.html#placing-separator-sheets_uk" title="Розміщення аркушів-розділювачів між копіями">
      Розміщення аркушів-розділювачів між копіями
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_uk" title="Скасування завдання друку">
      Скасування завдання друку
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-toner-darkness-topic.html#adjusting-toner-darkness_uk" title="Коригування щільності тонера">
      Коригування щільності тонера
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="copying.html#copying_uk" title="Копіювання">
     Копіювання
    </a>
   </p>
   <div id="divd0e6566">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-copy-topic.html#using-ADF-and-scanner-glass-copy_uk" title="Використання автоматичного подавача документів і скла сканера">
      Використання автоматичного подавача документів і скла сканера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="making-copies-topic.html#making-copies_uk" title="Виготовлення копій">
      Виготовлення копій
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-photos-topic.html#copying-photos_uk" title="Копіювання фотографій">
      Копіювання фотографій
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-transparencies-or-letterhead-topic.html#copying-transparencies-or-letterhead_uk" title="Копіювання на фірмовому бланку">
      Копіювання на фірмовому бланку
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-on-both-sides-of-paper-topic.html#copying-on-both-sides-of-paper_uk" title="Копіювання на обох сторонах паперу">
      Копіювання на обох сторонах паперу
     </a>
    </p>
    <p class="toc-2-style">
     <a href="reducing-enlarging-copies-topic.html#reducing-enlarging-copies_uk" title="Зменшення або збільшення розміру копії">
      Зменшення або збільшення розміру копії
     </a>
    </p>
    <p class="toc-2-style">
     <a href="collating-copies-topic.html#collating-copies_uk" title="Розбирання за копіями">
      Розбирання за копіями
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-between-copies-topic.html#placing-separator-sheets-between-copies_uk" title="Розміщення аркушів-розділювачів між копіями">
      Розміщення аркушів-розділювачів між копіями
     </a>
    </p>
    <p class="toc-2-style">
     <a href="saving-paper-topic.html#saving-paper_uk" title="Копіювання кількох сторінок на один аркуш">
      Копіювання кількох сторінок на один аркуш
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-cards-topic.html#copying-cards_uk" title="Копіювання карток">
      Копіювання карток
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-copy-shortcut-topic.html#creating-copy-shortcut_uk" title="Створення ярлика копіювання">
      Створення ярлика копіювання
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="E-mailing.html#E-mailing_uk" title="Електронна пошта">
     Електронна пошта
    </a>
   </p>
   <div id="divd0e6877">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-e-mail-topic.html#using-ADF-and-scanner-glass-e-mail_uk" title="Використання автоматичного подавача документів і скла сканера">
      Використання автоматичного подавача документів і скла сканера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-email-topic.html#sending-email_uk" title="Надсилання електронної пошти">
      Надсилання електронної пошти
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-email-shortcut-topic.html#creating-email-shortcut-using-control-panel_uk" title="Створення ярлика електронного листа">
      Створення ярлика електронного листа
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="Faxing.html#Faxing_uk" title="Факс">
     Факс
    </a>
   </p>
   <div id="divd0e6971">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-fax-topic.html#using-ADF-and-scanner-glass-fax_uk" title="Використання автоматичного подавача документів і скла сканера">
      Використання автоматичного подавача документів і скла сканера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-fax-topic.html#sending-fax_uk" title="Надсилання факсу">
      Надсилання факсу
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scheduling-fax-topic.html#scheduling-fax_uk" title="Планування факсу">
      Планування факсу
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-fax-destination-shortcut-topic.html#creating-fax-destination-shortcut_uk" title="Створення ярлика адресата факсу">
      Створення ярлика адресата факсу
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-fax-resolution-topic.html#changing-fax-resolution_uk" title="Зміна роздільної здатності факсу">
      Зміна роздільної здатності факсу
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-fax-darkness-topic.html#adjusting-fax-darkness_uk" title="Регулювання затемнення факсу">
      Регулювання затемнення факсу
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-fax-log-topic.html#printing-fax-log_uk" title="Друк журналу факсів">
      Друк журналу факсів
     </a>
    </p>
    <p class="toc-2-style">
     <a href="blocking-junk-faxes-topic.html#blocking-junk-faxes_uk" title="Блокування не6ажаних факсів">
      Блокування не6ажаних факсів
     </a>
    </p>
    <p class="toc-2-style">
     <a href="holding-faxes-topic.html#holding-faxes_uk" title="Відкладення факсів">
      Відкладення факсів
     </a>
    </p>
    <p class="toc-2-style">
     <a href="forwarding-fax-topic.html#forwarding-fax_uk" title="Пересилання факсу">
      Пересилання факсу
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="FTP.html#FTP_uk" title="Сканування">
     Сканування
    </a>
   </p>
   <div id="divd0e7336">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-scan-topic.html#using-ADF-and-scanner-glass-scan_uk" title="Використання автоматичного подавача документів і скла сканера">
      Використання автоматичного подавача документів і скла сканера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-computer-topic.html#scanning-to-computer_uk" title="Сканування на комп&rsquo;ютер">
      Сканування на комп&rsquo;ютер
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-ftp-server-using-control-panel-topic.html#scanning-ftp-server-using-control-panel_uk" title="Сканування на сервер FTP">
      Сканування на сервер FTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-FTP-shortcut-topic.html#creating-FTP-shortcut_uk" title="Створення ярлика FTP">
      Створення ярлика FTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="s2a-scanning-to-network-folders-topic.html#s2a-scanning-to-network-folders_uk" title="Сканування в мережеву папку">
      Сканування в мережеву папку
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-network-folder-shortcut-topic.html#creating-network-folder-shortcut_uk" title="Створення ярлика мережевої папки">
      Створення ярлика мережевої папки
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-flash-drive-topic.html#scanning-to-flash-drive_uk" title="Сканування на флешнакопичувач">
      Сканування на флешнакопичувач
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="understanding-printer-menus-chapter.html#understanding-printer-menus-chapter_uk" title="Використання меню принтера">
     Використання меню принтера
    </a>
   </p>
   <div id="divd0e7638">
    <p class="toc-2-style">
     <a href="menu-map-mfp-topic.html#menu-map-mfp_uk" title="Карта меню">
      Карта меню
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e8019" title="Пристрій">
      Пристрій
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e10354" title="Друк">
      Друк
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e11517" title="Папір">
      Папір
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copy-defaults-topic.html#d0e11877" title="Копіювання">
      Копіювання
     </a>
    </p>
    <p class="toc-2-style">
     <a href="fax-defaults-subgroup.html#d0e12449" title="Факс">
      Факс
     </a>
    </p>
    <p class="toc-2-style">
     <a href="email-setup-topic.html#d0e14877" title="Електронна пошта">
      Електронна пошта
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ftp-defaults-topic.html#d0e15893" title="FTP">
      FTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="flash-drive-scan-topic.html#d0e16539" title="USB-накопичувач">
      USB-накопичувач
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e17340" title="Мережа/порти">
      Мережа/порти
     </a>
    </p>
    <p class="toc-2-style">
     <a href="login-methods-subgroup.html#d0e19484" title="Безпека">
      Безпека
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cloud-services-enrollment-topic.html#d0e20634" title="Хмарні служби">
      Хмарні служби
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e20691" title="Звіти">
      Звіти
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-menu-topic.html#troubleshooting-menu_uk" title="Troubleshooting">
      Troubleshooting
     </a>
    </p>
    <p class="toc-2-style">
     <a href="forms-merge-topic.html#forms-merge_uk" title="Forms Merge (Злиття форм)">
      Forms Merge (Злиття форм)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-topic.html#printing-menu-settings-page_uk" title="Друк Menu Settings Page">
      Друк Menu Settings Page
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_uk" title="Технічне обслуговування принтера">
     Технічне обслуговування принтера
    </a>
   </p>
   <div id="divd0e21235">
    <p class="toc-2-style">
     <a href="checking-status-of-parts-and-supplies-topic.html#checking-status-of-parts-and-supplies_uk" title="Перевірка стану деталей і витратних матеріалів">
      Перевірка стану деталей і витратних матеріалів
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-supply-notifications-topic.html#configuring-supply-notifications_uk" title="Налаштування сповіщень про витратні матеріали">
      Налаштування сповіщень про витратні матеріали
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-e-mail-alert-topic.html#setting-up-e-mail-alert_uk" title="Налаштування сповіщень електронною поштою">
      Налаштування сповіщень електронною поштою
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-reports-topic.html#viewing-reports_uk" title="Перегляд звітів">
      Перегляд звітів
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-supplies-group.html#ordering-supplies-group_uk" title="Замовлення запчастин і матеріалів">
      Замовлення запчастин і матеріалів
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-toner-cartridge-topic.html#d0e21568" title="Заміна запчастин і матеріалів">
      Заміна запчастин і матеріалів
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#d0e21911" title="Очищення деталей принтера">
      Очищення деталей принтера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-power-save-mode-settings-topic.html#d0e22058" title="Економія енергії та паперу">
      Економія енергії та паперу
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-printer-topic.html#moving-printer_uk" title="Переміщення принтера в інше місце">
      Переміщення принтера в інше місце
     </a>
    </p>
    <p class="toc-2-style">
     <a href="shipping-printer-topic.html#shipping-printer_uk" title="Транспортування принтера">
      Транспортування принтера
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_uk" title="Усунення несправностей">
     Усунення несправностей
    </a>
   </p>
   <div id="divd0e22212">
    <p class="toc-2-style">
     <a href="print-quality-problems-picker-topic.html#print-quality-problems-picker_uk" title="Проблема з якістю друку">
      Проблема з якістю друку
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-error-codes-topic.html#printer-error-codes_uk" title="Коди помилок принтера">
      Коди помилок принтера
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printing-problems.html#solving-printing-problems_uk" title="Проблеми з друком">
      Проблеми з друком
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-printer-not-responding-topic.html#trb-printer-not-responding_uk" title="Принтер не відповідає">
      Принтер не відповідає
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-unable-to-read-flash-drive-topic.html#trb-unable-to-read-flash-drive_uk" title="Не вдається зчитати флешнакопичувач">
      Не вдається зчитати флешнакопичувач
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-usb-port-topic.html#enabling-usb-port_uk" title="Увімкнення порту USB">
      Увімкнення порту USB
     </a>
    </p>
    <p class="toc-2-style">
     <a href="clearing-jams.html#clearing-jams_uk" title="Усування зминання">
      Усування зминання
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e25884" title="Проблеми підключення до мережі">
      Проблеми підключення до мережі
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-detect-internal-option-topic.html#d0e26112" title="Проблеми параметрів апаратного забезпечення">
      Проблеми параметрів апаратного забезпечення
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e26260" title="Проблеми з витратними матеріалами">
      Проблеми з витратними матеріалами
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-envelope-seals-when-printing-topic.html#d0e26383" title="Проблеми з подачею паперу">
      Проблеми з подачею паперу
     </a>
    </p>
    <p class="toc-2-style">
     <a href="disabling-smtp-server-not-setup-error-topic.html#d0e26749" title="Проблеми з електронною поштою">
      Проблеми з електронною поштою
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-caller-id-not-shown-topic.html#d0e26843" title="Проблеми з надсиланням факсу">
      Проблеми з надсиланням факсу
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-scan-to-computer-topic.html#d0e27488" title="Проблеми сканування">
      Проблеми сканування
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_uk" title="Зверніться до служби підтримки клієнтів">
      Зверніться до служби підтримки клієнтів
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="recycle-dispose-chapter.html#recycle-dispose-chapter_uk" title="Переробка й утилізація">
     Переробка й утилізація
    </a>
   </p>
   <div id="divd0e28268">
    <p class="toc-2-style">
     <a href="recycling-lexmark-products-topic.html#recycling-lexmark-products_uk" title="Переробка виробів Lexmark">
      Переробка виробів Lexmark
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_uk" title="Переробка пакування Lexmark">
      Переробка пакування Lexmark
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_uk" title="Сповіщення">
     Сповіщення
    </a>
   </p>
   <div id="divd0e28305">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28308" title="Інформація про виріб">
      Інформація про виріб
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28325" title="Сповіщення про випуск">
      Сповіщення про випуск
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_uk" title="Торгові марки">
      Торгові марки
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_uk" title="Сповіщення про ліцензію">
      Сповіщення про ліцензію
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_uk" title="Рівні шуму">
      Рівні шуму
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#weee-directive_uk" title="Директива щодо відпрацьованого електричного й електронного обладнання (WEEE)">
      Директива щодо відпрацьованого електричного й електронного обладнання (WEEE)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28431" title="Літій-іонний акумулятор із перезарядкою">
      Літій-іонний акумулятор із перезарядкою
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#eu-battery-directive-2023-1542_uk" title="Регламент (ЄС) 2023/1542">
      Регламент (ЄС) 2023/1542
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28469" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_uk" title="Утилізація виробу">
      Утилізація виробу
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_uk" title="Сповіщення про статичну чутливість">
      Сповіщення про статичну чутливість
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_uk" title="ENERGY STAR">
      ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_uk" title="Інформація про температуру">
      Інформація про температуру
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice_uk" title="Сповіщення про лазер">
      Сповіщення про лазер
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_uk" title="Споживання електроенергії">
      Споживання електроенергії
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#regulatory-notices-for-telecommunication-terminal-equipment_uk" title="Повідомлення про нормативні вимоги до телекомунікаційного термінального обладнання">
      Повідомлення про нормативні вимоги до телекомунікаційного термінального обладнання
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28716" title="Сповіщення про нормативні вимоги до бездротових виробів">
      Сповіщення про нормативні вимоги до бездротових виробів
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#modular-component-notice_uk" title="Повідомлення про модульний компонент">
      Повідомлення про модульний компонент
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#exposure-to-radio-frequency-radiation_uk" title="Потрапляння під вплив радіочастотного випромінювання">
      Потрапляння під вплив радіочастотного випромінювання
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28741" title="Відповідність директивам Європейського співтовариства (ЄС)">
      Відповідність директивам Європейського співтовариства (ЄС)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#european-community-ec-directives-conformity-class-a_uk" title="Відповідність директивам Європейського співтовариства (ЄС)">
      Відповідність директивам Європейського співтовариства (ЄС)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#radio-interference-notice_uk" title="Повідомлення про радіоперешкоди">
      Повідомлення про радіоперешкоди
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue